<template>
  <div class="answerNew">
    <div class="title">
      <div class="breadCrumb">
        <span @click="returnanswer(newId)">课程回答 ></span>
        <span>发表新问答</span>
      </div>
    </div>
    <div class="box">
      <div class="tab">
        <h2><span>*</span>标题</h2>
        <input
          type="text"
          v-model="title"
        >
      </div>
      <div class="tag">
        <h2><span>*</span>标签</h2>
        <div class="log">
          <input
            v-model="isTag"
            type="text"
            placeholder="输入标签名"
          >
          <span class="add"><img
              @click="add"
              src="../assets/course/add.png"
              alt=""
            ></span>
          <ul>
            <li
              v-for="(item,index) in log"
              :key="index"
            >
              {{item}}
              <img
                @click="remove(index)"
                src="../assets/course/remove.png"
                alt=""
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="con">
        <h2>内容</h2>
        <div class="hezi">
          <textarea
            v-model="con"
            placeholder="输入内容"
          ></textarea>
        </div>
      </div>
      <div
        class='tobtn'
        @click="tosubmit"
      >
        发表提问
      </div>
    </div>
  </div>
</template>

<script>
import { getaskApi } from "@/request/api";
export default {
  name: "answerNew",
  data() {
    return {
      con: "",
      title: "",
      isTag: "",
      log: ["难点", "求建议", "求解答"],
      newId: "",
      info: {
        title: "",
        tag: [],
        content: "",
        courseId: "",
      },
    };
  },
  created() {
    this.newId = JSON.parse(this.$Base64.decode(this.$route.query.id));
    this.join = JSON.parse(this.$Base64.decode(this.$route.query.joined));
  },
  methods: {
    returnanswer(id) {
      this.$router.push({ path: "/answer", query: { id, joined: this.join } });
    },
    add() {
      if (this.isTag) {
        this.log.push(this.isTag);
        this.isTag = "";
      } else {
        this.$message.info("标签不能为空");
      }
    },
    remove(index) {
      this.log.splice(index, 1);
    },
    tosubmit() {
      this.info.title = this.title;
      this.info.tag = this.log;
      this.info.content = this.con;
      this.info.courseId = this.newId;
      this.info.title = this.info.title.replace(/(^\s*)|(\s*$)/g, ""); //去空格
      this.info.content = this.info.content.replace(/(^\s*)|(\s*$)/g, "");

      if (
        this.info.title == "" ||
        this.info.title == undefined ||
        this.info.title == null
      ) {
        this.$message.error("标题不能为空");
      } else {
        if (this.info.tag.length) {
          if (
            this.info.content == "" ||
            this.info.content == undefined ||
            this.info.content == null
          ) {
            this.$message.error("内容不能为空");
          } else {
            this.getToken(getaskApi, this.info, () => {
              this.$message.success("提问提交成功！");
              // this.$router.push({path:'/answer'})
            });
            this.log = ["难点", "求建议", "求解答"];
            this.con = "";
            this.title = "";
          }
        } else {
          this.$message.error("标签不能为空！");
        }

        // if(this.info.content==""||this.info.content==undefined||this.info.content==null){
        //       this.$message.error('内容不能为空')
        //   }else{
        //         this.getToken(getaskApi,this.info,res=>{
        //       this.$message.success("提问提交成功，请等待审核！")
        //       })
        //       this.log=["难点","求建议","求解答"]
        //       this.con=''
        //       this.title='' 
        //   }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.answerNew {
  >.title {
    margin: 0 auto;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;

    .breadCrumb {
      min-width: 230px;
      height: 20px;
      margin-bottom: 8px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #333333;

      span:last-child {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 1px;
        color: #999999;
      }

      span:hover {
        color: #f0cd48;
        cursor: pointer;
      }
    }
  }

  .box {
    .tab {
      margin-bottom: 25px;

      h2 {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #333333;
        margin-bottom: 10px;

        span {
          color: red;
          padding-right: 3px;
        }
      }

      input {
        width: 873px;
        min-height: 38px;
        background-color: #ffffff;
        border: solid 1px #dfdfdf;
        outline: none;
      }

      input:focus {
        border: solid 1px #f0cd48;
      }
    }

    .tag {
      margin-bottom: 30px;

      h2 {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #333333;
        margin-bottom: 10px;

        span {
          color: red;
          padding-right: 3px;
        }
      }

      .log {
        display: flex;

        input {
          width: 107px;
          height: 38px;
          background-color: #ffffff;
          box-shadow: 0px 0px 0px 0px rgba(34, 34, 34, 0.26);
          border: solid 1px #dfdfdf;
          outline: none;
          text-indent: 5px;
        }

        .add {
          width: 17px;
          height: 17px;
          line-height: 38px;
          margin-left: 8px;
          margin-right: 30px;

          img {
            widht: 100%;
            height: 100%;
          }
        }
      }

      ul {
        display: flex;
        margin-bottom: 0;
        flex-wrap: wrap;

        li {
          min-width: 80px;
          height: 38px;
          background-color: #e3f8ff;
          border: solid 1px #bfdfff;
          color: #666666;
          font-size: 14px;
          line-height: 38px;
          text-align: center;
          margin-right: 12px;
          position: relative;
          padding-left:5px;   
          padding-right:5px;
          margin-bottom:5px;
          img {
            width: 16px;
            height: 16px;
            position: absolute;
            right: -8px;
            top: -8px;
          }
        }

        li:last-child {
          margin-right: 0px;
        }
      }
    }

    .con {
      h2 {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 15px;
      }

      .hezi {
        min-height: 248px;

        textarea {
          width: 100%;
          min-height: 248px;
          outline: none;
          padding: 10px;
          outline: none;
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }

  .tobtn {
    width: 101px;
    height: 38px;
    background-color: #f0cd48;
    border-radius: 3px;
    letter-spacing: 1px;
    color: #ffffff;
    font-size: 14px;
    padding: 0px;
    text-align: center;
    line-height: 38px;
    margin-top: 18px;
    margin-left: 10px;
  }
}
</style>
